<ion-loading
  #loading
  [isOpen]="isOpen()"
  (didPresent)="dismissUnlessLoading(loading)"
  cssClass="bl-loading"
  spinner="crescent"
  keyboardClose
  data-cy="loading"
/>
